var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.244873,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.24487,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_6298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4473 25.8057H52.8745C53.5694 25.8057 54.1328 26.369 54.1328 27.064V52.4912C54.1328 53.1862 53.5694 53.7496 52.8745 53.7496H27.4473C26.7523 53.7496 26.1889 53.1862 26.1889 52.4912V27.064C26.1889 26.369 26.7523 25.8057 27.4473 25.8057Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1578 19.374C38.5105 19.374 37.1751 18.0386 37.1751 16.3912C37.1751 14.7439 38.5105 13.4084 40.1578 13.4084C41.8052 13.4084 43.1406 14.7439 43.1406 16.3912C43.1406 18.0386 41.8052 19.374 40.1578 19.374Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9469 22.3567C25.2996 22.3567 23.9641 21.0212 23.9641 19.3739C23.9641 17.7265 25.2996 16.3911 26.9469 16.3911C28.5943 16.3911 29.9297 17.7265 29.9297 19.3739C29.9297 21.0212 28.5943 22.3567 26.9469 22.3567Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5172 29.2134C17.8699 29.2134 16.5344 27.8779 16.5344 26.2306C16.5344 24.5832 17.8699 23.2478 19.5172 23.2478C21.1646 23.2478 22.5 24.5832 22.5 26.2306C22.5 27.8779 21.1646 29.2134 19.5172 29.2134Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1618 42.76C14.5144 42.76 13.179 41.4246 13.179 39.7772C13.179 38.1299 14.5144 36.7944 16.1618 36.7944C17.8091 36.7944 19.1445 38.1299 19.1445 39.7772C19.1445 41.4246 17.8091 42.76 16.1618 42.76Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5172 55.759C17.8699 55.759 16.5344 54.4236 16.5344 52.7762C16.5344 51.1289 17.8699 49.7935 19.5172 49.7935C21.1646 49.7935 22.5 51.1289 22.5 52.7762C22.5 54.4236 21.1646 55.759 19.5172 55.759Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6618 63.1633C25.0144 63.1633 23.679 61.8279 23.679 60.1805C23.679 58.5332 25.0144 57.1978 26.6618 57.1978C28.3091 57.1978 29.6445 58.5332 29.6445 60.1805C29.6445 61.8279 28.3091 63.1633 26.6618 63.1633Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1578 66.5918C38.5105 66.5918 37.1751 65.2563 37.1751 63.609C37.1751 61.9617 38.5105 60.6262 40.1578 60.6262C41.8052 60.6262 43.1406 61.9617 43.1406 63.609C43.1406 65.2563 41.8052 66.5918 40.1578 66.5918Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.443 63.1633C51.7957 63.1633 50.4602 61.8279 50.4602 60.1805C50.4602 58.5332 51.7957 57.1978 53.443 57.1978C55.0903 57.1978 56.4258 58.5332 56.4258 60.1805C56.4258 61.8279 55.0903 63.1633 53.443 63.1633Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8024 55.759C59.155 55.759 57.8196 54.4236 57.8196 52.7762C57.8196 51.1289 59.155 49.7935 60.8024 49.7935C62.4497 49.7935 63.7852 51.1289 63.7852 52.7762C63.7852 54.4236 62.4497 55.759 60.8024 55.759Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2985 42.76C62.6511 42.76 61.3157 41.4246 61.3157 39.7772C61.3157 38.1299 62.6511 36.7944 64.2985 36.7944C65.9458 36.7944 67.2812 38.1299 67.2812 39.7772C67.2812 41.4246 65.9458 42.76 64.2985 42.76Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8024 29.2134C59.155 29.2134 57.8196 27.8779 57.8196 26.2306C57.8196 24.5832 59.155 23.2478 60.8024 23.2478C62.4497 23.2478 63.7852 24.5832 63.7852 26.2306C63.7852 27.8779 62.4497 29.2134 60.8024 29.2134Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.443 22.6423C51.7957 22.6423 50.4602 21.3069 50.4602 19.6595C50.4602 18.0122 51.7957 16.6768 53.443 16.6768C55.0903 16.6768 56.4258 18.0122 56.4258 19.6595C56.4258 21.3069 55.0903 22.6423 53.443 22.6423Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4609 19.6594C50.1504 19.6772 48.4715 19.8039 47.3004 21.2066C46.2615 22.4511 46.0204 24.2233 46.6576 25.8055",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7366 19.6594C30.0472 19.6772 31.7261 19.8039 32.8972 21.2066C33.9361 22.4511 34.1772 24.2233 33.54 25.8055",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4609 59.8949C50.1504 59.8771 48.4715 59.7504 47.3004 58.3477C46.2615 57.1032 46.0204 55.331 46.6576 53.7488",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7366 59.8949C30.0472 59.8771 31.7261 59.7504 32.8972 58.3477C33.9361 57.1032 34.1772 55.331 33.54 53.7488",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1602 19.3738V25.8054",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1602 53.7495V60.6262",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3164 39.7773H54.1309",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1447 39.7773H26.1875",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8008 29.2134C60.703 29.8034 60.4363 30.8345 59.6169 31.7456C57.6163 33.9712 54.3019 33.2773 54.1313 33.2384",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5181 29.2134C19.6158 29.8034 19.8825 30.8345 20.7019 31.7456C22.7025 33.9712 26.0169 33.2773 26.1875 33.2384",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8008 49.7934C60.703 49.2034 60.4363 48.1723 59.6169 47.2611C57.6163 45.0356 54.3019 45.7295 54.1313 45.7684",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5181 49.7934C19.6158 49.2034 19.8825 48.1723 20.7019 47.2611C22.7025 45.0356 26.0169 45.7295 26.1875 45.7684",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7384 31.7451H37.4806V37.0679H31.8111V42.7601H37.1756V48.1035H42.7384V42.7601H48.3828V37.3279H42.7295L42.7384 31.7451Z",
    stroke: "#24CCFF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_6298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "matrix(-1 0 0 1 70 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon01);
export default __webpack_public_path__ + "static/media/choose_icon01.baa1970c81ff7550d471f27d1ea05064.svg";
export { ForwardRef as ReactComponent };